enum ChessClockStatus {
  Ready,
  Started,
  Ended
}

export default ChessClockStatus